import React from 'react';
import TagsDisplay from './tagsDisplay';
import PermitsDisplay from './permitsDisplay';

const ViewProfile = props => {
  return (
    <div
      className="container-view-profile"
    >
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.email + ":"}
			</label>
			<div className="profile-entry-value">
				<span>{props.datos.userName ? props.datos.userName : ""}</span>
			</div>
		</div>
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.categories + ":"}
			</label>
			<div className="profile-entry-value">
				<TagsDisplay 
					language={props.language} 
					filter={props.filter} 
					tags={props.datos.filterTags} 
				/>
			</div>
		</div>
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.fitbitState + ":"}
			</label>
			<div className="profile-entry-value">
				<span>
					{props.datos.isAuthenticated ? 
					props.language.user_profile.detail.connect : 
					props.language.user_profile.detail.disconnect}
				</span>
			</div>
		</div>
    </div>
  );
};
export default ViewProfile;



// WEBPACK FOOTER //
// ./source/client/components/user_profile/viewProfile.jsx